import React from 'react'
import { useSelector } from 'react-redux'
import objectQuery from 'loankeeper-common/containers/objectQuery'

import { getLivedata } from '../../../store/livedata'

export const useLivedata = (query = '* as livedata') => {
  const data = useSelector(getLivedata)

  return React.useMemo(() => objectQuery(data, query), [query, data])
}

/**
 * HOC that fetches and then passes livedata to your component
 *
 * @param {Object} config
 * @param {ObjectQuery} [query='* as livedata'] @see ObjectQuery
 *
 * @returns {function(component: React.Component): React.Component} HOC
 */
const withLivedata = (query) => (Component) => (props) => {
  const livedataState = useLivedata(query)

  return <Component {...props} {...livedataState} />
}

export default withLivedata
